import React from 'react';
import urlBase from '../../url-base';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';


class ChooseImageTopSite extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      msg: false,
      error: false,
      showInput: true
    };

    this.styles = {
      paper: {
        padding: 10
      }
    };
  }


  componentDidMount() {
    
  }
  fileToBase64() {
    if (document.getElementById('file')) {
      let file = document.getElementById('file').files[0];
      let reader = new FileReader();

      reader.onloadend = function() {
        this.sendImage(reader.result);
      }.bind(this);
      reader.readAsDataURL(file);
    }
  }
  sendImage(codeImage) {
    let dataSubmit = {
      code: codeImage
    };

    document.getElementById('loading').style.display = 'block';

    axios.post(urlBase.loopBack + 'attachments/saveImageTopSite', dataSubmit)
    .then(() => {
      document.getElementById('file').value = '';
      document.getElementById('loading').style.display = 'none';
      let state = this.state;
      state.showInput = false;
      state.msg = true;
      state.error = false;
      this.setState(state);
    })
    .catch(function () {
      document.getElementById('loading').style.display = 'none';
      let state = this.state;
      state.msg = false;
      state.error = true;
      this.setState(state);
    }.bind(this));
  }
  resend() {
    let state = this.state;
    state.showInput = true;
    state.msg = false;
    state.error = false;
    this.setState(state);
  }

  render() {
    return (
      <div>
        <Paper elevation={1} style={this.styles.paper}>

          <div id="loading" style={{ display: 'none'}}>
            <i
              style={{ marginLeft: 5, width: 16, marginBottom: 20 }}
              className="fa fa-spinner fa-spin">
              &nbsp;
            </i>
          </div>

          {
            this.state.msg == true ? (
            <div>
              <div className="alert alert-success" role="alert">
                Arquivo enviado com sucesso
              </div>
              <br/>
            </div>
            ) : ('')
          }

          {
            this.state.error == true ? (
            <div>
              <div className="alert alert-danger" role="alert">
                Erro ao enviar arquivo
              </div>
              <br/>
            </div>
            ) : ('')
          }

          {
            this.state.showInput == true ? (
            <div>
              <input id="file" type="file" />
              <br/>
              <br/>
              <button onClick={this.fileToBase64.bind(this)}>
                Enviar
              </button>
            </div>
            ) : (
            <div>
              <button onClick={this.resend.bind(this)}>
                Enviar Outro
              </button>
            </div>
            )
          }
        </Paper>
      </div>
    );

  }

}

export default ChooseImageTopSite;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/ChooseImageTopSite.js
 **/